import cns from 'classnames';
import download from 'downloadjs';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { getFileWithSignedUrl } from '../../../shared/actions/Files';
import Image from '../../../shared/components/Image';
import { SEGMENT_EVENTS } from '../../../shared/Constants';
import { createUserCertificate, IMAGE_PROPS, overlayImageIds } from '../../../shared/utils/ImageUtils';
import CertificateImageWidget from '../../components/widgets/CertificateImageWidget';

export default class MyCollectionTrackAchievement extends Component {
    static propTypes = {
        userCollection: PropTypes.object,
        loggedInUserCompany: PropTypes.object,
        badgesById: PropTypes.object,
        isVerbAdmin: PropTypes.bool,
        loggedInUser: PropTypes.object
    };

    static contextType = RuntimeContext;

    _handleReferenceSheetDownload = (resourceUrl) => {
        const { loggedInUserCompany, isVerbAdmin, userCollection } = this.props;
        getFileWithSignedUrl(this.context.pathsWeb, resourceUrl);
    };

    _downloadCert = (certUrl, fileName) => {
        const { loggedInUserCompany, isVerbAdmin } = this.props;
        return fetch(certUrl)
            .then((res) => res.blob())
            .then((blob) => download(blob, fileName));
    };

    _renderCertificate = () => {
        const { userCollection, loggedInUser } = this.props;

        const userName = `${loggedInUser.firstName || ''} ${loggedInUser.lastName}`;
        const date = userCollection.completedOn || userCollection.updatedOn;
        const certificateUrl = createUserCertificate(userName, userCollection.name, date, 'COLLECTION');

        const certFileName = `${userCollection.collectionName.split(' ').join('_')}_Certificate`;

        const userCollectionIsCompleted = userCollection.status === 'COMPLETED';

        return (
            <CertificateImageWidget
                label={'Certificate'}
                onClick={userCollectionIsCompleted ? () => this._downloadCert(certificateUrl, certFileName) : () => {}}
                id={userCollection.collectionId}
                imageUrl={userCollection.thumbnailImageUrl}
                fontAwesomeIcon={userCollectionIsCompleted ? 'graduation-cap' : 'lock-alt'}
                className={cns('certificate', { unlocked: userCollectionIsCompleted })}
            />
        );
    };

    _renderReferenceSheets = () => {
        const { userCollection } = this.props;

        const userCollectionIsCompleted = userCollection.status === 'COMPLETED';

        const referenceSheets = get(userCollection, 'resources', []) || [];

        return (
            <Fragment>
                {referenceSheets.map((resource, i) => (
                    <div
                        key={`${resource.url}-${i}`}
                        className={'reference-sheet-container'}
                        onClick={
                            !userCollectionIsCompleted
                                ? () => this._handleReferenceSheetDownload(resource.url)
                                : () => {}
                        }
                    >
                        <div className={cns('reference-sheet img-circle', { unlocked: !userCollectionIsCompleted })}>
                            <i
                                className={cns('fal', {
                                    'fa-file-alt': !userCollectionIsCompleted,
                                    'fa-lock-alt': userCollectionIsCompleted
                                })}
                            />
                        </div>
                        <h4>Reference Sheet</h4>
                    </div>
                ))}
            </Fragment>
        );
    };

    _renderBadge = () => {
        const { badgesById, userCollection } = this.props;

        if (badgesById[userCollection.badgeId]) {
            const imageProps = IMAGE_PROPS.collectionImageCloudinary;

            const userCollectionIsCompleted = userCollection.status === 'COMPLETED';

            const badgeImageOverlay = !userCollectionIsCompleted
                ? {
                      overlayId: overlayImageIds.locked,
                      dimension: {
                          h: 250,
                          w: 250
                      }
                  }
                : {};
            return (
                <div className={'badge-container'}>
                    <Image
                        src={badgesById[userCollection.badgeId].image}
                        overlay={badgeImageOverlay}
                        dimension={imageProps.dimension}
                        cloudinaryCrop={imageProps.cloudinaryCrop}
                        className={'badge-image img-circle'}
                    />
                    <h4>Badge</h4>
                </div>
            );
        }

        return null;
    };

    _renderCredentialSection = () => {
        const { userCollection } = this.props;

        if (!userCollection.type || userCollection.type === 'STANDARD') {
            return (
                <div className={'credentials-section'}>
                    <div className={'container credentials-container'}>
                        {this._renderBadge()}
                        {this._renderCertificate()}
                        {this._renderReferenceSheets()}
                    </div>
                </div>
            );
        }
        return <br />;
    };

    render() {
        return <div className={'my-collection-track-growth-tab'}>{this._renderCredentialSection()}</div>;
    }
}
